import React from "react";
import { useTranslation } from "react-i18next";

import styles from "./index.module.scss";

export default function SessionBasicInfo({ sessionData }) {
  const { t } = useTranslation();

  // helper function to get values under "session" in data object
  const getSessionValue = field => {
    return sessionData ? sessionData[field] : undefined;
  };

  return (
    <>
      <div className={styles.row}>
        <div className={styles.rowLeft}>{t("coachingSummary.coach")}</div>
        <div className={styles.rowRight}>{getSessionValue("coach_name")}</div>
      </div>
      <div
        className={`${styles.row} ${
          getSessionValue("scorecard_id") && styles.noPaddingBottom
        }`}
      >
        <div className={styles.rowLeft}>{t("coachingSummary.coachee")}</div>
        <div className={styles.rowRight}>{getSessionValue("coachee_name")}</div>
      </div>
    </>
  );
}
